import React from 'react'
import ShortInfoCard from '../ShortInfoCard'
import { shortFunction, shortFunctionMenu, openAi } from '../../translate'
import { useNavigate } from 'react-router-dom'
export default function OpenAi() {
    const navigate = useNavigate()
    return (
        <>
            <h3 style={{ margin: '20px 20px' }}>{openAi.openai[+localStorage.getItem('atsLang') || 1]}</h3>

            <div className="short-cards">
                <ShortInfoCard
                    label={`${openAi.openai_title[+localStorage.getItem('atsLang') || 1]}`}
                    description={openAi.openai_desc[+localStorage.getItem('atsLang') || 1]}
                    onEdit={() => navigate('/short_function/openai', { state: { from: 'openai-card' } })}
                >
                    <span/>
                </ShortInfoCard>
                <ShortInfoCard
                    label={`${openAi.wav_title[+localStorage.getItem('atsLang') || 1]}`}
                    description={openAi.wav_desc[+localStorage.getItem('atsLang') || 1]}
                    onEdit={() => navigate('/short_function/openai', { state: { from: 'wav-card' } })}
                >
                    <span/>
                </ShortInfoCard>
                <ShortInfoCard
                    label={`${openAi.ai_analytics_title[+localStorage.getItem('atsLang') || 1]}`}
                    description={openAi.ai_analytics_desc[+localStorage.getItem('atsLang') || 1]}
                    onEdit={() => navigate('/short_function/ai_analytics')}
                >
                    <span/>
                </ShortInfoCard>
            </div>
        </>
    )
}
